import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'getname'})
export class GetNamePipe implements PipeTransform {
    transform(value: string, world: number): string {
        const splitBy = ' '
        const splitText = value?.trim().split(splitBy);
        let name = value;

        if (world == 1 && splitText?.length > 0) {
            name = splitText[0]
        } else {
            if (splitText?.length > 2) {
                name = splitText[splitText.length - 1]
            } else if (splitText?.length == 2) {
                name = splitText[1]
            }
        }

        return name;
    }
}
